import { GET_CANCELLATION } from '../../constants/actions/policy';

export function getCancellation(payload) {
    return {
        type: GET_CANCELLATION,
        payload,
    };
}
